const enumErrors = {
  required: {
    title: "No Value Specified",
    description: "Enum option cannot be empty.",
  },
  validValue: {
    title: "Invalid option",
    description:
      "Invalid enum option. Options must be numbers or “quoted” strings.",
  },
  unique: {
    title: "Duplicate Name",
    description: "Enum option must be unique",
  },
} as const;

export const getEnumError = (errorType: string) => {
  return errorType in enumErrors
    ? enumErrors[errorType as keyof typeof enumErrors]
    : null;
};

export const isValidEnumOptionInput = (input: string | undefined): boolean => {
  if (!input) {
    return false;
  }

  // Check if input is a boolean literal
  if (input === "true" || input === "false") {
    return true;
  }

  // Check if input is a valid number
  if (!isNaN(Number(input))) {
    return true;
  }

  // Check for both double-quoted and single-quoted strings
  return isValidQuotedString(input);
};

export const isValidQuotedString = (input: string): boolean => {
  if (input.startsWith('"') && input.endsWith('"')) {
    return (input.match(/"/g) || []).length === 2;
  } else if (input.startsWith("'") && input.endsWith("'")) {
    return (input.match(/'/g) || []).length === 2;
  }
  return false;
};

export const validateUniqueEnumOptions = (
  valueArg: string,
  otherEnums: unknown,
) => {
  if (!otherEnums || !Array.isArray(otherEnums)) {
    return false;
  }

  const otherValues = otherEnums
    .map((otherEnum: unknown) =>
      otherEnum && typeof otherEnum === "object" && "value" in otherEnum
        ? otherEnum.value
        : "",
    )
    .filter(Boolean);

  return otherValues.filter((value) => value === valueArg).length < 2;
};
